import "./LandingPageNav.css";

const SECTIONS = [
  { id: "platform", label: "Возможности" },
  { id: "products", label: "Продукты" },
  { id: "audience", label: "Для кого" },
  { id: "why", label: "Почему MOGAME" },
  { id: "motivation", label: "Мотивация" },
  { id: "create", label: "Создание" },
  { id: "launch", label: "Запуск" },
  { id: "analytics", label: "Аналитика" },
  { id: "cases", label: "Примеры" },
  { id: "faq", label: "Вопросы" },
];

export default function LandingPageNav({ variant = "inline" }) {
  return (
    <nav
      className={`landing-page-nav landing-page-nav--${variant}`}
      aria-label="Разделы главной страницы"
    >
      <div className="landing-page-nav__inner">
        {SECTIONS.map(({ id, label }) => (
          <a key={id} href={`#${id}`} className="landing-page-nav__link">
            {label}
          </a>
        ))}
      </div>
    </nav>
  );
}
